export type Coordinates = {
  x: number;
  y: number;
};

export const MAX_LENGTH = 512;
export const MIN_LENGTH = 1;

export const STROKE_SIZES: StrokeSize[] = [1, 3, 5];
export type StrokeSize = 1 | 3 | 5;
